module.exports = __webpack_public_path__ + "img/asistbt-logo.2ab2aa81.svg";